export default "__VITE_ASSET__BdrNHdCQ__"